import { AggregatedGatewayType, OrderListStatus, SubOrderSecondaryStatus } from '@/types/squidward-api'

import { SingleStatus } from './type'

export const pageTitles: Record<string, string> = {
    '/cart': 'سبد خرید',
    '/checkout/shipping': 'شیوه و زمان ارسال',
    '/checkout/payment': 'شیوه پرداخت',
}

export enum FaSingleStatus {
    All = 'همه',
    Shipped = 'ارسال شده',
    Processing = 'ثبت شده',
    Canceled = 'لغو شده',
}

export const SubStatusPersian: Record<SubOrderSecondaryStatus, string> = {
    Submitted: 'ثبت شده',
    ProcessWmsCreated: 'در حال آماده‌سازی',
    ProcessWmsWaitToConfirm: 'در حال آماده‌سازی',
    ProcessWmsConfirmed: 'در حال آماده‌سازی',
    ProcessWmsLacked: 'در حال آماده‌سازی',
    ProcessWmsInProcessLacked: 'در حال آماده‌سازی',
    ProcessStarted: 'در حال آماده‌سازی',
    ProcessInProgress: 'در حال آماده‌سازی',
    ProcessPending: 'در حال آماده‌سازی',
    ProcessCompleted: 'در حال آماده‌سازی',
    ProcessCanceled: 'در حال آماده‌سازی',
    Shipping: 'تحویل به مرکز توزیع',
    DeliveryAssigned: 'تحویل به راننده',
    DeliveryStarted: 'در راه مقصد',
    DeliveryWaiting: 'در حال تحویل',
    DeliveryNoReceiver: 'عدم حضور مشتری',
    DeliveryCanceled: 'عدم پاسخگویی مشتری',
    DeliveryRejected: 'عدم دریافت توسط مشتری',
    DeliveryCompleted: 'تحویل شده',
    Cancelled: 'لغو شده',
    Draft: '',
    ProcessWmsCompleted: '',
    InPudo: 'در مرکز تحویل حضوری',
}

export const AggregatedGatewayTypeFa: Record<AggregatedGatewayType, string> = {
    Bank: 'درگاه پرداخت اینترنتی',
    Credit: 'اعتبار خانومی',
    Digipay: 'پرداخت اعتباری با دیجی پی',
    SnappPay: 'اسنپ پی',
    Tara: 'پرداخت اعتباری با تارا',
}

export const FILTERS: SingleStatus[] = [
    { id: undefined, name: FaSingleStatus.All, param: '' },
    { id: OrderListStatus.Processing, name: 'جاری', param: 'in_progress' },
    { id: OrderListStatus.Shipped, name: FaSingleStatus.Shipped, param: 'shipped' },
    { id: OrderListStatus.Canceled, name: FaSingleStatus.Canceled, param: 'canceled' },
]

export const PAGE_SIZE = 10
